import Colors from './colors';
import Footer from './footer';
import Head from './head';
import Header from './header';
import Layout from './layout';
import Platforms from './platforms';

export { Colors, Footer, Head, Header, Layout, Platforms };
